export const DataLayer = {
  sync(state) {
    const purposes = Object.entries(state).filter(([, v]) => v).map(([k]) => k);
    (window.dataLayer = window.dataLayer || []).push({ event: 'nedaware_cmp_consent_update', purposes });
  },
};
